import { Link } from 'react-router-dom';
import { ArrowRight, HelpCircle, Scale, Calculator, BookOpen } from 'lucide-react';

const typeConfig = {
  quiz: {
    badge: 'Quiz',
    badgeClass: 'badge-quiz',
    icon: HelpCircle,
  },
  estimation: {
    badge: 'Schätzspiel',
    badgeClass: 'badge-estimation',
    icon: Calculator,
  },
  decision: {
    badge: 'Entscheidungshilfe',
    badgeClass: 'badge-quiz',
    icon: Scale,
  },
  advisor: {
    badge: 'Ratgeber',
    badgeClass: 'badge-advisor',
    icon: BookOpen,
  },
};

export const GameCard = ({ 
  title, 
  description, 
  image, 
  path, 
  type = 'quiz',
  featured = false 
}) => {
  const config = typeConfig[type] || typeConfig.quiz;
  const Icon = config.icon;

  return (
    <Link 
      to={path}
      className={`game-card card-hover ${featured ? 'bento-featured' : ''}`}
      data-testid={`game-card-${path.replace(/\//g, '-').slice(1)}`}
    >
      <div className="relative overflow-hidden">
        <img 
          src={image} 
          alt={title}
          className="game-card-image transform transition-transform duration-500 hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-4 left-4">
          <span className={`badge ${config.badgeClass}`}>
            <Icon size={12} className="mr-1" />
            {config.badge}
          </span>
        </div>
      </div>
      <div className="game-card-content">
        <h3 className="font-[var(--font-heading)] font-semibold text-lg md:text-xl text-[#0F172A] mb-2">
          {title}
        </h3>
        <p className="text-[#475569] text-sm md:text-base mb-4 flex-1">
          {description}
        </p>
        <div className="flex items-center text-[#0284C7] font-medium text-sm group">
          <span>Jetzt starten</span>
          <ArrowRight size={16} className="ml-2 transform transition-transform duration-200 group-hover:translate-x-1" />
        </div>
      </div>
    </Link>
  );
};

export default GameCard;
